import { jwtDecode } from "jwt-decode";
import axiosInstance from "../../axios";

export const setSession = (accessToken: any) => {
  if (accessToken !== "") {
    localStorage.setItem("accessToken", accessToken);
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem("accessToken");
    delete axiosInstance.defaults.headers.common.Authorization;
  }
};
const isValidToken = (accessToken: any) => {
  const currentTime = Date.now() / 1000;
  return accessToken.exp > currentTime;
};

export const decodeToken = (accessToken: any) => {
  const decodedToken = jwtDecode(accessToken);
  const isValid = isValidToken(decodedToken);
  if (isValid) {
    return true;
  } else {
    localStorage.removeItem("accessToken");
    delete axiosInstance.defaults.headers.common.Authorization;
    return null;
  }
};
